import React from 'react';
import CommonBanner from '../CommonBanner';
import Vision from '../../assets/images/vision.jpg';

const OurVision = () => {

  return (
    <div>
      <div className="border-b border-gray-200 mt-2"></div>
      <CommonBanner 
        topTitle="Our Story"
        bannerImage={Vision}
        bannerImageAlt="Duralyze Story Image"
        bannerTitle="How We Started"
        welcomeTitle=""
        welcomeDescription={
          <div>
            <div className='text-left mb-6'>Founded in 2024 by Dr. Asim Riaz, Duralyze builds on over 8 years of academic expertise and direct collaboration with leading Australian industries on innovative green energy projects. We are dedicated to accelerating Australia’s transition to sustainable energy by offering:</div>
            <ul className="list-disc pl-5 space-y-2 text-left ml-4 md:ml-8">
              <li><span className='font-medium'>Tailored Consultancy:</span> Customized solutions for unique sustainability goals.</li>
              <li><span className='font-medium'>Cutting-Edge Technology:</span> Innovative approaches to green energy challenges.</li>
              <li><span className='font-medium'>Strategic Partnerships:</span> Collaboration with industry leaders and researchers.</li>
            </ul>
          </div>
        }
      />
    </div>
  )
}

export default OurVision;
